import { OrderQueryScopeEnum } from "../../enums/order-query-scope.enum";
import { DataScope } from "../data-scope";
import { Page } from "../page";

export class ShipmentProgressSearchParams extends Page {
  orderQueryScope: OrderQueryScopeEnum;
  orderStatus: number | null;
  consigneeCompany: string;
  selectedFacility: Array<String>;
  doNos: Array<string>;
  estimateLeaveDtStart: Date | null;
  estimateLeaveDtEnd: Date | null;
  dataScopes: DataScope | null;
  orgIds: Array<String>;
  invoiceNos: Array<String>;
  invoiceDtStart: Date | null;
  invoiceDtEnd: Date | null;
  leaveWarehouseDtStart: Date | null;
  leaveWarehouseDtEnd: Date | null;
  salesCodes: Array<String>;
  csr: String | null;
  facility: String | null;
  mergeKeys: Array<String>;
  customerPOs: Array<String>;
  frontLineDocStatus: String | null;

  constructor() {
    super();
    this.orderQueryScope = OrderQueryScopeEnum.all;
    this.orderStatus = null;
    this.consigneeCompany = '';
    this.selectedFacility = [];
    this.doNos = [];
    this.estimateLeaveDtStart = null;
    this.estimateLeaveDtEnd = null;
    this.dataScopes = null;
    this.orgIds = [];
    this.invoiceNos = [];
    this.salesCodes = [];
    this.csr = null;
    this.invoiceDtStart = null;
    this.invoiceDtEnd = null;
    this.leaveWarehouseDtStart = null;
    this.leaveWarehouseDtEnd = null;
    this.facility = null;
    this.mergeKeys = [];
    this.customerPOs = [];
    this.frontLineDocStatus = null;
  }
}
